// @ts-nocheck
import createTimetableWidget from './createTimetableWidget';
export default ({ editorAPI }) =>
  createTimetableWidget({
    editorAPI,
  });
